import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, post, put } from '../models/base';

export const fetchClientAlbum = createAsyncThunk(
  'client/fetchClientAlbum',
  async (albumId, { rejectWithValue }) => {
    try {
      const response = await get(`/api/client_albums/${albumId}`);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchClientFolders = createAsyncThunk(
  'client/fetchClientFolders',
  async (_, { rejectWithValue, getState }) => {
    const { album } = getState().client;
    try {
      const response = await get(
        `/api/client_albums/${album.id}/client_folders`
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchClientFolder = createAsyncThunk(
  'client/fetchClientFolder',
  async (folderId, { rejectWithValue, getState }) => {
    const { album } = getState().client;
    try {
      const response = await get(
        `/api/client_albums/${album.id}/client_folders/${folderId}`
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const updateClientFolder = createAsyncThunk(
  'client/updateClientFolder',
  async (_, { rejectWithValue, getState }) => {
    const { album, selectionFolder } = getState().client;

    try {
      const response = await put(
        `/api/client_albums/${album.id}/client_folders/${selectionFolder.id}`,
        {
          folder: {
            selected_status: 'done',
          },
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchClientPhotos = createAsyncThunk(
  'client/fetchClientPhotos',
  async (folderId, { rejectWithValue, getState }) => {
    const { album, pageNumber, perPage, folders, albumPin, selectedTab } =
      getState().client;
    folderId = folderId || folders[0].id;

    let queryPath = `/api/client_albums/${album.id}/client_folders/${folderId}/client_photos?page=${pageNumber}&per_page=${perPage}&album_pin=${albumPin}`;

    if (selectedTab === 'selected') {
      queryPath = `/api/client_albums/${album.id}/client_folders/${folderId}/client_photos?page=${pageNumber}&per_page=${perPage}&album_pin=${albumPin}&selected=true`;
    }

    try {
      const response = await get(queryPath);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const updateClientPhoto = createAsyncThunk(
  'client/updateClientPhoto',
  async (photoData, { rejectWithValue, getState }) => {
    const { album, selectionFolder } = getState().client;
    const { option, selected } = photoData;

    try {
      await put(
        `/api/client_albums/${album.id}/client_folders/${selectionFolder.id}/client_photos/${option.id}`,
        {
          photo: {
            selected,
          },
        }
      );
      return { ...option, selected: selected };
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchClientVideos = createAsyncThunk(
  'client/fetchClientVideos',
  async (folderId, { rejectWithValue, getState }) => {
    const { album, folders } = getState().client;

    folderId = folderId || folders[0].id;

    try {
      const response = await get(
        `/api/client_albums/${album.id}/client_folders/${folderId}/client_videos`
      );

      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const verifyAlbumPin = createAsyncThunk(
  'client/verifyAlbumPin',
  async (albumId, { rejectWithValue, getState }) => {
    const { albumPin } = getState().client;

    try {
      const response = await fetch(
        `/api/client_albums/${albumId}/verify_pin/?album_pin=${albumPin}`
      );
      if (!response.ok) {
        throw `GET ${res.status} ${res.url}`;
      }
      return response.status;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const submitClientEnquiry = createAsyncThunk(
  'client/submitClientEnquiry',
  async (data, { rejectWithValue, getState }) => {
    const { company } = getState().company;
    const { name, contactNumber } = data;

    try {
      const response = await post(
        `/api/client_companies/${company.id}/client_enquiries`,
        {
          enquiry: {
            contact_number: contactNumber,
            name,
          },
        }
      );

      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
